const unit = {
    name: '',
    nameDe: '',
    type: 'Metric',
};

export const formInitialValues = {
    unit,
};
